<script setup lang="ts">
import { map, groupBy } from 'lodash-es';
import { type FragmentType, graphql } from '@/gql';
import PartnerGroupedServicePreview from './PartnerGroupedServicePreview.vue';

const partnerServiceFragment = graphql(/* GraphQL */ `
  fragment PartnerGroupedServicePreviewList_PartnerServiceFragment on PartnerService {
    id
    service {
      id
      specialization {
        id
        name
      }
    }
    parameters {
      id
    }
    ...PartnerGroupedServicePreview_PartnerServiceFragment
  }
`);

const props = withDefaults(
  defineProps<{
    services: FragmentType<typeof partnerServiceFragment>[];
  }>(),
  { services: () => [] }
);

const services = useFragmentArrayData(
  partnerServiceFragment,
  () => props.services
);
const serviceGroups = computed(() => {
  const groups = groupBy(
    services.value,
    (service) => service.service.specialization.name
  );
  return map(groups, (services, name) => ({
    name,
    services,
  }));
});
</script>

<template>
  <div class="service-groups">
    <PartnerGroupedServicePreview
      v-for="group in serviceGroups"
      :key="group.name"
      :title="group.name"
      :services="group.services"
    />
  </div>
</template>

<style lang="scss" scoped>
.service-groups {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: var(--app-spacing-6);

  @include media-breakpoint-down(sm) {
    gap: var(--app-spacing-5);
  }
}
</style>
